import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils'; const cls = classNames('slice-contact-form');
import { Classable, HasChildren, Slice, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { ContactForm, ContactFormProps } from '../elements/contact-form';
import AnimateHeight from 'react-animate-height';
import { ContentEntityContent, ExpandButton, useCookieLevel, useEntity, useLang } from '@shapeable/ui';

// -------- Types -------->

export type SliceContactFormVariant = 'inline' | 'reveal';

export type SliceContactFormProps = Classable & HasChildren & ContactFormProps & { 
  entity?: Slice;
  variant?: SliceContactFormVariant;
  formComponent?: React.FC<ContactFormProps>;
};

export const SliceContactFormDefaultProps: Omit<SliceContactFormProps, 'entity'> = {
  variant: 'reveal',
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom ${theme.UNIT(20)};
  `,
});

const BodyStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  `,
});


const ContentStyles = breakpoints({
  base: css`
    max-width: 700px;
    width: 100%;
  `,
});

const ButtonStyles = breakpoints({
  base: css`
    margin-top: ${theme.UNIT(8)};
    margin-bottom: ${theme.UNIT(8)};
  `,
});

const FormStyles = breakpoints({
  base: css`
    width: 100%;
    box-sizing: border-box;
    margin-top: ${theme.UNIT(10)};
    max-width: 700px;
  `,
});

const FormRevealStyles = breakpoints({
  base: css`
    overflow: hidden;
    transition: height 0.3s;
  `,
});



// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
  Body: styled.div.attrs(cls.attr('body'))`${BodyStyles}`,
    Content: styled(ContentEntityContent)`${ContentStyles}`,
    Button: styled(ExpandButton)`${ButtonStyles}`,

    FormReveal: styled.div.attrs(cls.attr('form-reveal'))`${FormRevealStyles}`,
    Form: styled(ContactForm)`${FormStyles}`,
};

export const SliceContactForm: Shapeable.FC<SliceContactFormProps> = (props) => {
  const { className, children, variant, ...contactFormProps } = props;
  const entity = useEntity(props.entity);
  const [ isExpanded, setIsExpanded ] = useState<boolean>(false);
  const [ cookies ] = useCookieLevel();
  const t = useLang();
  
  const Form = props.formComponent || My.Form;

  return (
    <My.Container className={className}>
        <My.Body>
          {/* <My.Content entity={entity} /> */}
          {
            variant === 'reveal' ?
            <>
            <My.Button 
              isExpanded={isExpanded}
              onClick={() => { setIsExpanded(!isExpanded) }}
              label={t('Show Contact Form')}
              expandedLabel={t('Hide Contact Form')} 
            />

            <AnimateHeight height={isExpanded ? 'auto' : 0}>
              <Form {...contactFormProps} /> 
            </AnimateHeight>
            </> : 
            <Form {...contactFormProps} /> 
          }
          
          {children}
        </My.Body>
      
    </My.Container>
  )
};

SliceContactForm.defaultProps = SliceContactFormDefaultProps;
SliceContactForm.cls = cls;